const MapSoftWere = [
    {
        name: '@ant-design/charts',
        version: '1.4.2',
        license: 'MIT License',
        copyright: 'Copyright (c) 2021 Ant Design',
    },
    {
        name: '@ant-design/icons',
        version: '4.7.0',
        license: 'MIT License',
        copyright: 'Copyright (c) 2021 Ant Design',
    },
    {
        name: '@antv/xflow',
        version: '1.0.50',
        license: 'MIT License',
        copyright: 'Copyright (c) 2021 Ant Design',
    },
    {
        name: '@headlessui/react',
        version: '1.6.6',
        license: 'MIT License',
        copyright: 'Copyright (c) 2020 Tailwind Labs',
    },
    {
        name: '@react-keycloak/web',
        version: '3.4.0',
        license: 'MIT License',
        copyright:
            'Copyright (c) 2019-present, Mattia Panzeri mattia.panzeri93@gmail.com',
    },
    {
        name: '@tailwindcss/typography',
        version: '0.5.2',
        license: 'MIT License',
        copyright: 'Copyright (c) Tailwind Labs, Inc.',
    },
    {
        name: 'antd',
        version: '4.20.0',
        license: 'MIT License',
        copyright:
            'Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/',
    },
    {
        name: 'antd-img-crop',
        version: '4.2.3',
        license: 'MIT License',
        copyright: 'Copyright (c) 2022 nanxiaobei',
    },
    {
        name: 'axios',
        version: '0.26.1',
        license: 'MIT License',
        copyright: 'Copyright (c) 2014-present Matt Zabriskie & Collaborators',
    },
    {
        name: 'classnames',
        version: '2.3.1',
        license: 'MIT License',
        copyright: 'Copyright (c) 2018 Jed Watson',
    },
    {
        name: 'framer-motion',
        version: '6.3.11',
        license: 'MIT License',
        copyright: 'Copyright (c) 2018 Framer B.V.',
    },
    {
        name: 'html-react-parser',
        version: '1.4.12',
        license: 'MIT License',
        copyright:
            'Copyright (c) 2016 Menglin "Mark" Xu <mark@remarkablemark.org>',
    },
    {
        name: 'html-to-image',
        version: '1.10.8',
        license: 'MIT License',
        copyright: 'Copyright (c) 2017 W.Y.',
    },
    {
        name: 'i18next',
        version: '21.6.14',
        license: 'MIT License',
        copyright: 'Copyright (c) 2022 i18next',
    },
    {
        name: 'i18next-browser-languagedetector',
        version: '6.1.4',
        license: 'MIT License',
        copyright: 'Copyright (c) 2022 i18next',
    },
    {
        name: 'i18next-http-backend',
        version: '1.4.0',
        license: 'MIT License',
        copyright: 'Copyright (c) 2022 i18next',
    },
    {
        name: 'immutability-helper',
        version: '3.1.1',
        license: 'MIT License',
        copyright: 'Copyright (c) 2017 Moshe Kolodny',
    },
    {
        name: 'keycloak-js',
        version: '17.0.1',
        license: 'Apache License',
    },
    {
        name: 'luxon',
        version: '3.0.4',
        license: 'MIT License',
        copyright: 'Copyright 2019 JS Foundation and other contributors',
    },
    {
        name: 'moment',
        version: '2.29.3',
        license: 'MIT License',
        copyright: 'Copyright (c) JS Foundation and other contributors',
    },
    {
        name: 'qrcode.react',
        version: '3.0.2',
        license: 'ISC License',
        copyright: 'Copyright (c) 2015, Paul O’Shannessy',
    },
    {
        name: 'react',
        version: '17.0.2',
        license: 'MIT License',
        copyright: 'Copyright (c) Meta Platforms, Inc. and affiliates.',
    },
    {
        name: 'react-animations',
        version: '1.0.0',
        license: 'MIT License',
        copyright: 'Copyright (c) 2016 Formidable Labs',
    },
    {
        name: 'react-beautiful-dnd',
        version: '13.1.1',
        license: 'Apache License',
        copyright: 'Copyright 2019 Atlassian Pty Ltd',
    },
    {
        name: 'react-checkbox-tree',
        version: '1.8.0',
        license: 'MIT License',
        copyright: 'Copyright (c) 2017 Jake Zatecky',
    },
    {
        name: 'react-color',
        version: '2.19.3',
        license: 'MIT License',
        copyright: 'Copyright (c) 2015 Case Sandberg',
    },
    {
        name: 'react-copy-to-clipboard',
        version: '5.1.0',
        license: 'MIT License',
        copyright: 'Copyright (c) 2016 Nik Butenko',
    },
    {
        name: 'react-dom',
        version: '17.0.2',
        license: 'MIT License',
        copyright: 'Copyright (c) Meta Platforms, Inc. and affiliates.',
    },
    {
        name: 'react-grid-carousel',
        version: '10.0.1',
        license: 'MIT License',
        copyright: 'Copyright (c) 2020 YY Chang',
    },
    {
        name: 'react-i18next',
        version: '11.16.1',
        license: 'MIT License',
        copyright: 'Copyright (c) 2022 i18next',
    },
    {
        name: 'react-infinite-scroll-component',
        version: '6.1.0',
        license: 'MIT License',
        copyright: 'Copyright (c) 2019 react-infinite-scroll-component',
    },
    {
        name: 'react-inject-env',
        version: '2.1.0',
        license: 'MIT License',
        copyright: 'Copyright (c) 2020 aelesia',
    },
    {
        name: 'react-jwt',
        version: '1.1.6',
        license: 'MIT License',
        copyright: 'Copyright (c) 2020 Gustavo Velazquez',
    },
    {
        name: 'react-router-dom',
        version: '6.3.0',
        license: 'MIT License',
        copyright:
            'Copyright (c) React Training 2015-2019 Copyright (c) Remix Software 2020-2022',
    },
    {
        name: 'react-scripts',
        version: '5.0.0',
        license: 'MIT License',
        copyright: 'Copyright (c) Meta Platforms, Inc. and affiliates.',
    },
    {
        name: 'react-slick',
        version: '0.29.0',
        license: 'MIT License',
        copyright: 'Copyright (c) 2014 Kiran Abburi',
    },
    {
        name: 'react-step-wizard',
        version: '5.3.11',
        license: 'MIT License',
        copyright: 'Copyright (c) 2017 Jason McNeal',
    },
    {
        name: 'react-step-wizard',
        version: '5.3.11',
        license: 'MIT License',
        copyright: 'Copyright (c) 2017 Captivation Software, LLC',
    },
    {
        name: 'react-sticky',
        version: '6.0.3',
        license: 'MIT License',
        copyright: 'Copyright (c) 2017 Captivation Software, LLC',
    },
    {
        name: 'react-sticky-el',
        version: '2.0.9',
        license: 'MIT License',
        copyright: 'Copyright (c) 2016 Mikhail Bogdanov',
    },
    {
        name: 'react-toastify',
        version: '9.0.3',
        license: 'MIT License',
        copyright: 'Copyright (c) 2022 Fadi Khadra',
    },
    {
        name: 'sass',
        version: '1.49.9',
        license: 'MIT License',
        copyright: 'Copyright (c) 2022, Google Inc.',
    },
    {
        name: 'shortid',
        version: '2.2.16',
        license: 'MIT License',
        copyright: 'Copyright (c) Dylan Greene All rights reserved.',
    },
    {
        name: 'styled-components',
        version: '5.3.5',
        license: 'MIT License',
        copyright:
            'Copyright (c) 2016-present Glen Maddern and Maximilian Stoiber',
    },
    {
        name: 'suneditor',
        version: '2.43.4',
        license: 'MIT License',
        copyright: 'Copyright (c) 2017 ~ JiHong.Lee',
    },
    {
        name: 'suneditor-react',
        version: '2.43.4',
        license: 'MIT License',
        copyright: 'Copyright (c) 2017 ~ JiHong.Lee',
    },
    {
        name: 'swiper',
        version: '8.1.4',
        license: 'MIT License',
        copyright: 'Copyright (c) 2019 Vladimir Kharlampidi',
    },
];

const MapLicense = {
    'MIT License': (
        <>
            <p>
                Permission is hereby granted, free of charge, to any person
                obtaining a copy of this software and associated documentation
                files (the "Software"), to deal in the Software without
                restriction, including without liMIT Licenseation the rights to
                use, copy, modify, merge, publish, distribute, sublicense,
                and/or sell copies of the Software, and to perMIT License
                persons to whom the Software is furnished to do so, subject to
                the following conditions:
            </p>
            <p>
                The above copyright notice and this permission notice shall be
                included in all copies or substantial portions of the Software.
            </p>
            <p>
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
                EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMIT LicenseED TO THE
                WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
                AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
                HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
                FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
                OTHER DEALINGS IN THE SOFTWARE.
            </p>
        </>
    ),
    'Apache License': (
        <>
            <p>
                Licensed under the Apache License, Version 2.0 (the "License");
                you may not use this file except in compliance with the License.
                You may obtain a copy of the License at
            </p>
            <p className="indent-8">
                http://www.apache.org/licenses/LICENSE-2.0
            </p>
            <p>
                Unless required by applicable law or agreed to in writing,
                software distributed under the License is distributed on an "AS
                IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
                express or implied. See the License for the specific language
                governing permissions and limitations under the License.
            </p>
        </>
    ),
    'ISC License': (
        <>
            <p>
                Permission to use, copy, modify, and/or distribute this software
                for any purpose with or without fee is hereby granted, provided
                that the above copyright notice and this permission notice
                appear in all copies.
            </p>
            <p>
                THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL
                WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
                WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR
                CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
                LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
                CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
        </>
    ),
};

const OpenSourceNotices = () => {
    const getLicense = (license) => MapLicense[license];
    return (
        <div className="w-full bg-[#f9fafe]">
            <div className="prose lg:max-w-7xl prose-slate py-6 mx-auto">
                <div className="w-36 h-36 bg-purple flex justify-center items-center">
                    <svg
                        width={181}
                        height={38}
                        viewBox="0 0 181 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M144.617 14.1348H151.999V15.9107H149.195V24.6951H147.421V15.9107H144.617V14.1348Z"
                            fill="white"
                        />
                        <path
                            d="M137.598 23.0324C138.437 23.0324 139.181 22.7651 139.83 22.2495L140.936 23.6435C140.44 24.0254 139.925 24.3119 139.391 24.5029C138.819 24.7129 138.208 24.8084 137.579 24.8084C136.873 24.8084 136.167 24.6747 135.5 24.3883C134.851 24.1209 134.279 23.739 133.783 23.2425C133.306 22.7651 132.925 22.1922 132.638 21.5429C132.371 20.8936 132.219 20.1871 132.219 19.4423C132.219 18.6975 132.352 18.01 132.638 17.3608C132.905 16.7306 133.306 16.1577 133.783 15.6421C134.279 15.1647 134.851 14.7827 135.5 14.4963C136.148 14.2289 136.854 14.0762 137.579 14.0762C138.189 14.0762 138.8 14.1717 139.391 14.3626C139.963 14.5727 140.478 14.8591 140.936 15.222L139.83 16.616C139.181 16.1004 138.437 15.8522 137.598 15.8522C137.102 15.8522 136.644 15.9476 136.206 16.1386C135.767 16.3296 135.385 16.5778 135.061 16.9025C134.737 17.2271 134.489 17.609 134.298 18.0482C134.107 18.4875 134.012 18.9458 134.012 19.4423C134.012 19.9388 134.107 20.3971 134.298 20.8363C134.489 21.2755 134.737 21.6575 135.061 21.9821C135.385 22.3068 135.767 22.5741 136.206 22.7651C136.644 22.9369 137.102 23.0324 137.598 23.0324Z"
                            fill="white"
                        />
                        <path
                            d="M123.922 14.1348C124.476 14.1348 125.01 14.2493 125.525 14.4594C126.04 14.6695 126.478 14.975 126.879 15.376C127.28 15.7771 127.585 16.2354 127.795 16.751C128.005 17.2666 128.1 17.8013 128.1 18.3551V24.7142H126.326V23.8358C125.983 24.1222 125.563 24.4087 125.067 24.6378C124.571 24.8861 123.999 25.0007 123.35 25.0007C122.854 25.0007 122.377 24.9243 121.9 24.7906C121.423 24.6569 121.004 24.4278 120.622 24.1413C120.241 23.8358 119.936 23.4538 119.707 22.9955C119.478 22.5372 119.363 21.9643 119.363 21.315C119.363 20.7421 119.478 20.2265 119.688 19.7682C119.916 19.329 120.203 18.9471 120.584 18.6415C120.966 18.336 121.404 18.1068 121.9 17.9541C122.396 17.8013 122.93 17.7249 123.484 17.7249C124.075 17.7249 124.609 17.8013 125.086 17.9541C125.563 18.1068 125.983 18.2787 126.326 18.4697V18.2214C126.326 17.8777 126.269 17.5721 126.135 17.2857C126.002 16.9992 125.83 16.7319 125.62 16.5218C125.41 16.2927 125.143 16.1208 124.857 15.9871C124.571 15.8534 124.247 15.7962 123.922 15.7962C123.484 15.7962 123.045 15.8343 122.644 15.8916C122.244 15.9489 121.881 16.0253 121.557 16.0826C121.233 16.159 120.985 16.2163 120.794 16.2736C120.603 16.3309 120.508 16.369 120.508 16.369L119.916 14.8413C119.936 14.8222 120.05 14.784 120.279 14.7268C120.508 14.6504 120.794 14.574 121.156 14.4976C121.519 14.4212 121.938 14.3448 122.415 14.2684C122.911 14.1729 123.407 14.1348 123.922 14.1348ZM123.674 23.5111C124.018 23.5111 124.323 23.4729 124.609 23.3966C124.895 23.3202 125.143 23.2247 125.372 23.1101C125.601 22.9955 125.792 22.8619 125.944 22.7282C126.097 22.5945 126.231 22.4799 126.345 22.3653V19.7873C126.116 19.6536 125.773 19.52 125.353 19.3863C124.933 19.2526 124.418 19.1762 123.827 19.1762C123.407 19.1762 123.026 19.2335 122.721 19.3481C122.396 19.4627 122.148 19.6154 121.938 19.8064C121.729 19.9974 121.576 20.2265 121.462 20.4748C121.366 20.723 121.309 21.0095 121.309 21.2959C121.309 21.7543 121.385 22.1171 121.538 22.4035C121.691 22.69 121.881 22.9191 122.11 23.0719C122.339 23.2438 122.606 23.3393 122.873 23.4157C123.14 23.492 123.407 23.5111 123.674 23.5111Z"
                            fill="white"
                        />
                        <path
                            d="M109.633 14.1348H116.004V15.9107H111.407V18.1259H115.279L114.993 19.9019H111.407V24.6951H109.633V14.1348Z"
                            fill="white"
                        />
                        <path
                            d="M105.513 19.5762H96.9674C96.9865 20.0727 97.1009 20.531 97.2917 20.9511C97.4824 21.3712 97.7495 21.7532 98.0738 22.0587C98.3981 22.3834 98.7796 22.6316 99.2183 22.8035C99.657 22.9945 100.115 23.0708 100.611 23.0708C101.317 23.0708 101.908 22.9754 102.404 22.7653C102.9 22.5552 103.32 22.2306 103.701 21.7723L105.055 22.9181C104.54 23.5483 103.93 24.0066 103.243 24.3312C102.48 24.6749 101.603 24.8468 100.611 24.8468C99.8859 24.8468 99.1802 24.7131 98.4934 24.4267C98.1692 24.293 97.8639 24.1212 97.5778 23.9302C97.2917 23.7392 97.0246 23.5101 96.7576 23.2809C96.5096 23.0326 96.2997 22.7462 96.109 22.4598C95.9182 22.1733 95.7466 21.8678 95.613 21.5431C95.3269 20.8556 95.1934 20.1491 95.1934 19.4234C95.1934 18.6786 95.3078 17.9912 95.5558 17.3419C95.8038 16.6926 96.1471 16.1197 96.605 15.6041C97.1009 15.0885 97.6732 14.6875 98.3408 14.4201C99.0275 14.1337 99.7715 14 100.573 14C101.24 14 101.889 14.1146 102.518 14.3628C103.091 14.592 103.606 14.9357 104.063 15.375C104.483 15.7951 104.827 16.2916 105.055 16.8454C105.303 17.3992 105.437 18.0103 105.456 18.6595L105.513 19.5762ZM103.529 18.0866C103.491 17.8002 103.396 17.5138 103.224 17.2273C103.052 16.9409 102.843 16.6926 102.595 16.4825C102.347 16.2725 102.041 16.0815 101.698 15.9669C101.355 15.8333 100.973 15.776 100.573 15.776C99.7143 15.776 98.9894 15.9669 98.4362 16.368C97.883 16.769 97.5015 17.3419 97.2917 18.1058H103.529V18.0866Z"
                            fill="white"
                        />
                        <path
                            d="M84.7207 14.1348H92.103V15.9107H89.2989V24.6951H87.5248V15.9107H84.7207V14.1348Z"
                            fill="white"
                        />
                        <path
                            d="M78.9785 14.1348H80.7525V24.6951H78.9785V14.1348Z"
                            fill="white"
                        />
                        <path
                            d="M72.7807 14.1348H74.5547V24.6951H72.7807V20.0929H67.7447V24.6951H65.9707V14.1348H67.7447V18.3169H72.7807V14.1348Z"
                            fill="white"
                        />
                        <path
                            d="M59.8269 14.1348H61.6963L58.0147 24.8861L54.8481 18.2596L51.6816 24.8861L48 14.1348H49.8694L51.9487 20.3602L54.8481 14.1729L57.7476 20.3602L59.8269 14.1348Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.7688 31.6131V31.6221H9.5V32.7205H17.567C19.1336 32.7205 20.6642 32.4054 22.0867 31.8202C23.5092 31.235 24.8057 30.3707 25.9131 29.2633C27.0206 28.1558 27.8849 26.8504 28.4701 25.4368C29.0553 24.0143 29.3704 22.4837 29.3704 20.9171V19.6387H28.263V20.9171C28.263 23.7532 27.1376 26.4722 25.1299 28.48C23.1221 30.4877 20.4031 31.6131 17.567 31.6131H11.7688Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.50977 27.0938H10.6172V17.9014C10.6172 15.1283 11.7156 12.4723 13.6783 10.5096C15.6411 8.54686 18.2971 7.44845 21.0701 7.44845H26.175V7.41244H29.3802V6.33203H21.0791C19.5485 6.33203 18.045 6.63815 16.6494 7.21436C15.2629 7.79058 13.9844 8.63689 12.895 9.7173C11.8056 10.7977 10.9593 12.0762 10.3921 13.4717C9.81588 14.8582 9.50977 16.3618 9.50977 17.9014V27.0938Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M29.3608 15.4968V14.3984H20.6185C20.2134 14.3984 19.8172 14.4795 19.4481 14.6325C19.079 14.7856 18.7458 15.0107 18.4577 15.2898C18.1696 15.5779 17.9445 15.911 17.8005 16.2801C17.6474 16.6493 17.5664 17.0454 17.5664 17.4506V17.7207C17.5664 18.1258 17.6474 18.522 17.8005 18.8911C17.9535 19.2603 18.1786 19.5934 18.4577 19.8815C18.7458 20.1696 19.079 20.3947 19.4481 20.5387C19.8172 20.6828 20.2134 20.7728 20.6185 20.7728H29.3608V19.6564H28.2444V19.6654C28.2444 19.6654 23.4096 19.6654 20.6185 19.6654C20.1054 19.6654 19.6102 19.4583 19.25 19.0982C18.8899 18.7381 18.6828 18.2429 18.6828 17.7297C18.6828 17.6397 18.6828 17.5496 18.6828 17.4596C18.6828 16.9464 18.8899 16.4512 19.25 16.0911C19.6102 15.7309 20.1054 15.5239 20.6185 15.5239H28.0823V15.5059H29.3608V15.4968Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.4512 17.1469C13.6132 15.3102 14.4685 13.6896 15.738 12.5282C17.0075 11.3577 18.7091 10.6555 20.5548 10.6555H29.3781V9.53906H20.5548C18.421 9.53906 16.4583 10.3584 14.9817 11.7089C13.5052 13.0594 12.5238 14.9411 12.3438 17.0659L12.902 17.6691L12.3438 17.1109V27.0866L13.4602 27.0956V17.1469H13.4512Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M24.8694 22.007C24.7073 23.8437 23.852 25.4643 22.5826 26.6258C21.3131 27.7962 19.6114 28.4985 17.7658 28.4985H9.55469V29.6149H17.7658C19.8996 29.6149 21.8623 28.7956 23.3388 27.4451C24.8154 26.0946 25.7968 24.2129 25.9768 22.0881V22.0521L26.0308 19.8102L24.9144 19.7832L24.8694 22.007Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M29.3444 12.0938H20.278C19.6027 12.0938 18.9365 12.2288 18.3152 12.4809C17.703 12.733 17.1358 13.1111 16.6586 13.5883C16.1814 14.0655 15.8033 14.6327 15.5512 15.2449C15.2991 15.8572 15.1641 16.5234 15.1641 17.2077L15.7223 17.7659L15.1641 17.2077V20.908H16.2805V17.2077L15.7223 17.7659L16.2805 17.2077C16.2805 16.6765 16.3885 16.1543 16.5866 15.6771C16.7847 15.1999 17.0818 14.7497 17.4509 14.3806C17.8291 14.0025 18.2702 13.7144 18.7474 13.5163C19.2246 13.3182 19.7468 13.2102 20.278 13.2102H29.3444V12.0938Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.1445 27.0588H18.0346C18.7099 27.0588 19.3761 26.9238 19.9973 26.6717C20.6096 26.4196 21.1768 26.0415 21.654 25.5643C22.1311 25.0871 22.5093 24.5199 22.7614 23.9077C23.0135 23.2954 23.1485 22.6292 23.1485 21.9449L22.5903 22.5031L23.1485 21.9449V19.9102H22.0321V21.9449L22.5903 22.5031L22.0321 21.9449C22.0321 22.4761 21.9241 22.9983 21.726 23.4755C21.5279 23.9527 21.2308 24.4028 20.8617 24.772C20.4835 25.1501 20.0424 25.4382 19.5652 25.6363C19.088 25.8344 18.5658 25.9424 18.0346 25.9424H15.1445V27.0588Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.6834 19.8828V21.0803C19.6834 21.6745 19.4403 22.2057 19.0532 22.6018C18.666 22.989 18.1258 23.2321 17.5316 23.2321H15.1367V24.3395H17.5316C18.432 24.3395 19.2423 23.9703 19.8365 23.3851C20.4307 22.7909 20.7908 21.9806 20.7908 21.0803V20.441L20.3047 20.0899L19.6834 19.8828Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M22.2036 18.3253L29.3342 18.2082L29.3162 17.0918L22.1855 17.2088L22.2036 18.3253Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <p className="font-semibold">OPEN SOURCE SOFTWARE NOTICES</p>
                {MapSoftWere.map((sw, i) => (
                    <div key={i}>
                        <p className="font-semibold">
                            The App may include the following open source
                            software:{' '}
                            <span className="text-purple">
                                {sw.name}@{sw.version}.
                            </span>{' '}
                            This software is governed by the following license:
                        </p>
                        <div className="text-gray-500 w-sm">
                            <p>{sw.license}</p>
                            <p>{sw.copyright}</p>
                            {getLicense(sw.license)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OpenSourceNotices;
